export enum AllowedCENavRoutes {
  Insured = '/ce-ucm-forms/ce-insured',
  Owner = '/ce-ucm-forms/ce-owner',
  Equipment = '/ce-ucm-forms/ce-equipment',
  Liability = '/ce-ucm-forms/ce-liability',
  LossPayee = '/contractors/coverages/losspayee',
  AdditionalInfo = '/ce-ucm-forms/ce-additionalinfo',
  GeneralQuestion = '/ce-ucm-forms/ce-generalquestion',
  Document = '/contractors/underwriting/documents',
  RenewalReview = '/ce-ucm-forms/ce-renewalreview',
  Snapshot = '/contractors/pending-review/policysnapshot',
  BRCoverage = '/contractors/pending-review/verifycoverage',
  BRPolicy = '/contractors/pending-review/verifypolicy',
  VPActionItems = '/contractors/verify-purchase/actionitems',
  VPCoverage = '/contractors/verify-purchase/coverages',
  VPPolicy = '/contractors/verify-purchase/policy'
}

export enum AllowedCEBoundNavRoutes {
  PolicyInfo = '/bound',
  Coverage = '/bound',
  Snapshot = '/bound',
  Declined = '/declined'
}

export enum CESubmissionRoutes {
  Step1A = AllowedCENavRoutes.Insured,
  Step1Address = AllowedCENavRoutes.Insured,
  Step1AUpdate = AllowedCENavRoutes.Insured,
  // Step1B = AllowedCENavRoutes.Owner,
  // Step1BUpdate = AllowedCENavRoutes.Owner,
  Step1B = AllowedCENavRoutes.Equipment,
  Step1BUpdate = AllowedCENavRoutes.Equipment,
  // Step1C = AllowedCENavRoutes.Equipment,
  // Step1CUpdate = AllowedCENavRoutes.Equipment,
  Step2A = AllowedCENavRoutes.Liability,
  Step2AUpdate = AllowedCENavRoutes.Liability,
  Step2B = AllowedCENavRoutes.LossPayee,
  Step2BUpdate = AllowedCENavRoutes.LossPayee,
  Step3A = AllowedCENavRoutes.GeneralQuestion,
  Step3AUpdate = AllowedCENavRoutes.GeneralQuestion,
  Step3C = AllowedCENavRoutes.Document,
  Step3CUpdate = AllowedCENavRoutes.Document,
  Renewal = AllowedCENavRoutes.RenewalReview,
  RenewalReview = AllowedCENavRoutes.RenewalReview,
  Step4A = AllowedCENavRoutes.VPActionItems,
  Step4CompForms = AllowedCENavRoutes.VPActionItems,
  Step4DwnloadDoc = AllowedCENavRoutes.VPActionItems,
  Step4InstBill = AllowedCENavRoutes.VPActionItems,
  Step4InstPaid = AllowedCENavRoutes.VPActionItems,
  Step4InsurForm = AllowedCENavRoutes.VPActionItems,
  Step4NewTxn = AllowedCENavRoutes.VPActionItems,
  Step4BRemFin = AllowedCENavRoutes.VPActionItems,
  Step4Purchase = AllowedCENavRoutes.VPActionItems,
  Step4Update = AllowedCENavRoutes.VPActionItems,
  EHelpUWReview = AllowedCENavRoutes.Snapshot,

  Declined = AllowedCEBoundNavRoutes.Declined,
  'Declined New Business' = AllowedCEBoundNavRoutes.Declined,
  'Declined Renewal' = AllowedCEBoundNavRoutes.Declined,
  EHelBReviewDoc = AllowedCEBoundNavRoutes.Snapshot,
  InspCreated = AllowedCEBoundNavRoutes.Snapshot,
  InspInfoRequest = AllowedCEBoundNavRoutes.Snapshot,
  InsBReview = AllowedCEBoundNavRoutes.Snapshot,
  PolicyBound = AllowedCEBoundNavRoutes.Snapshot,
  StepENAddChange = AllowedCEBoundNavRoutes.Snapshot,
  StepENAIChange = AllowedCEBoundNavRoutes.Snapshot,
  StepENExpChange = AllowedCEBoundNavRoutes.Snapshot,
  InspCompleted = AllowedCEBoundNavRoutes.Snapshot
}
